module.exports = __webpack_public_path__ + "img/book2-1.17cd710d.jpg";